<template>
  <button
      :type="type"
      class="save-button"
      :disabled="loading || disabled"
      @click="$emit('click')">

    <span
        v-if="loading"
        class="spinner-border spinner-border-sm save-spinner"
        role="status"
        aria-hidden="true">
    </span>

    <i v-else class="fa-solid fa-check save-button-icon"></i>
    <span class="save-button-text">
      {{ loading ? $t('general.button.save_in_progress') : label }}
    </span>
  </button>
</template>

<script setup>
import {computed, defineEmits, defineProps} from 'vue';
import {piniaCompanySettingsStore} from "@/store/piniaCompanySettingsStore";

const piniaCompanySettingsState = piniaCompanySettingsStore()
const companySettings = computed(() => piniaCompanySettingsState.companySettings)
const companyColor = computed(() => companySettings.value?.colorCode || '#15803d')

defineProps({
  label: {
    type: String,
    default: 'Speichern'
  },
  loading: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  type: {
    type: String,
    default: 'submit'
  }
})

defineEmits(['click'])
</script>

<style scoped>
.save-button {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  border: 1px solid v-bind(companyColor);
  color: #ffffff;
  background-color: v-bind(companyColor);
  padding: 6px 14px;
  border-radius: 4px;
  font-size: 13.5px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  user-select: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.save-button:hover:not(:disabled) {
  filter: brightness(0.9);
  transform: translateY(-1px);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.08);
}

.save-button-icon {
  font-size: 14px;
  color: #ffffff;
}

.save-spinner {
  width: 15px;
  height: 15px;
  border-width: 2px;
  color: #ffffff;
}

.save-button:disabled {
  cursor: not-allowed;
  opacity: 0.75;
  filter: brightness(0.95) grayscale(10%);
}

.save-button-text {
  white-space: nowrap;
}
</style>
